import { useQuery } from "@tanstack/react-query";
import invariant from "shared/utils/invariant";
import { queryClient } from "../../../../shared/api/queryClient";
import { getSettingModuleDetails } from "../api/getSettingModuleDetails";

type Params = { moduleId: string | null; brandId: string; settingId: string };

export const useSettingModuleDetailsQuery = ({
  moduleId,
  brandId,
  settingId,
}: Params) => {
  return useQuery({
    queryKey: ["settingModuleDetails", { moduleId, settingId, brandId }],
    queryFn: async () => {
      invariant(moduleId);
      return await getSettingModuleDetails({
        moduleId,
        settingId,
        brandId,
      });
    },
    staleTime: 0,
  });
};

export const invalidateSettingModuleDetails = async ({
  moduleId,
  brandId,
  settingId,
}: Params) => {
  await queryClient.invalidateQueries({
    queryKey: ["settingModuleDetails", { moduleId, settingId, brandId }],
  });
};
